(function(){
  /* bundles */
  document.querySelectorAll('.ovg-form').forEach(function(f){
    f.querySelectorAll('.bundle').forEach(function(c){
      c.addEventListener('click',function(){
        f.querySelectorAll('.bundle').forEach(function(x){x.classList.remove('selected')});
        c.classList.add('selected'); c.querySelector('input').checked=true;
        var p=document.getElementById('stP'),cc=document.getElementById('stC');
        if(p)p.textContent=c.dataset.price; if(cc)cc.textContent=c.dataset.compare;
      });
    });
  });

  /* reveal on scroll */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}})},{threshold:.18});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});

  /* count-up stats */
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return; cio.unobserve(e.target);
    var el=e.target,n=+el.dataset.n,t0=Date.now();
    var iv=setInterval(function(){ var k=Math.min((Date.now()-t0)/1200,1); el.textContent=Math.round(n*(1-Math.pow(1-k,3))); if(k>=1)clearInterval(iv); },30);
  })},{threshold:.6});
  document.querySelectorAll('.count').forEach(function(el){cio.observe(el)});

  /* mechanism steps: light up as they scroll into view */
  var sec=document.getElementById('mechSec');
  var steps=document.querySelectorAll('.mstep');
  function drip(){
    if(!sec)return;
    var r=sec.getBoundingClientRect(),vh=innerHeight;
    var prog=Math.min(Math.max((vh*0.72-r.top)/(r.height*0.9),0),1);
    steps.forEach(function(s,i){ s.classList.toggle('on',prog>(i+0.25)/steps.length); });
  }

  /* journey nodes light up */
  var jio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('on')})},{threshold:.6});
  document.querySelectorAll('.jnode').forEach(function(el){jio.observe(el)});

  /* floating honey decor (Elare-style parallax) */
  function makeFloats(id,count){
    var host=document.getElementById(id); if(!host)return[];
    var arr=[];
    for(var i=0;i<count;i++){
      var d=document.createElement('div'); d.className='float';
      var s=14+Math.random()*20;
      d.style.left=(4+Math.random()*92)+'%';
      d.style.top=(6+Math.random()*80)+'%';
      d.dataset.speed=(0.05+Math.random()*0.16).toFixed(3);
      d.innerHTML='<svg width="'+s+'" height="'+(s*1.25)+'" viewBox="0 0 20 25"><path d="M10 1 C10 1 3 11 3 16 a7 7 0 0 0 14 0 C17 11 10 1 10 1 Z" fill="rgba(232,167,35,'+(0.28+Math.random()*0.4).toFixed(2)+')"/></svg>';
      host.appendChild(d); arr.push(d);
    }
    return arr;
  }
  var floats=[].concat(makeFloats('floats1',7),makeFloats('floats2',7),makeFloats('floats3',6));
  function para(){
    var y=scrollY;
    floats.forEach(function(f){ f.style.transform='translateY('+(y*f.dataset.speed%140-70)+'px)'; });
  }

  /* sticky mobile ATC once we scroll into the continuation */
  var sticky=document.getElementById('stickyAtc'),ovgRoots=document.querySelectorAll('.ovg-pdp');
  function stick(){ if(!sticky||!ovgRoots.length)return; var first=ovgRoots[0].getBoundingClientRect(),last=ovgRoots[ovgRoots.length-1].getBoundingClientRect(); sticky.classList.toggle('show', first.top<40 && last.bottom>320); }

  /* rAF loop keeps drip + parallax + sticky-bar updating even when the theme swallows scroll events */
  function ovgRaf(){ drip(); para(); stick(); requestAnimationFrame(ovgRaf); }
  requestAnimationFrame(ovgRaf);
  addEventListener('scroll',function(){ drip(); para(); stick(); },{passive:true});
  addEventListener('resize',function(){ drip(); stick(); });

  /* CTAs scroll to the native buy box (single cart form in the theme's main-product section) */
  function ovgFindBuy(){ return document.querySelector('product-form, form[action*="/cart/add"], .product-form, .shopify-product-form, .product-form__buttons, .product__info-wrapper'); }
  function ovgScrollBuy(e){ if(e&&e.preventDefault)e.preventDefault(); var t=ovgFindBuy(); if(t&&t.scrollIntoView){ t.scrollIntoView({behavior:'smooth',block:'center'}); } else { window.scrollTo({top:0,behavior:'smooth'}); } }
  document.querySelectorAll('.ovg-pdp .atc[href^="#"], .ovg-pdp #offer .bundle').forEach(function(el){ if(el.dataset.ovgCta)return; el.dataset.ovgCta='1'; el.addEventListener('click',ovgScrollBuy); });

  /* Review cards: five at a time, with four-line previews for longer stories. */
  var reviewSection=document.getElementById('reviews');
  if(reviewSection && !reviewSection.dataset.reviewReady){
    reviewSection.dataset.reviewReady='1';
    var reviewCards=[].slice.call(reviewSection.querySelectorAll('.rev-card'));
    var reviewMore=reviewSection.querySelector('.rev-load-more');
    function prepareReview(card){
      var body=card.querySelector('.rev-body'),copy=card.querySelector('.rev-copy'),toggle=card.querySelector('.rev-toggle');
      if(!body || !copy || !toggle || body.classList.contains('expanded'))return;
      toggle.hidden=!(copy.scrollHeight>copy.clientHeight+2);
    }
    reviewCards.forEach(function(card){if(!card.hidden)prepareReview(card);});
    reviewSection.addEventListener('click',function(event){
      var toggle=event.target.closest('.rev-toggle');
      if(toggle && reviewSection.contains(toggle)){
        var body=toggle.closest('.rev-body'),expanded=body.classList.toggle('expanded');
        toggle.setAttribute('aria-expanded',String(expanded));
        toggle.innerHTML=expanded?reviewSection.dataset.readLessHtml:reviewSection.dataset.readMoreHtml;
        return;
      }
      if(event.target.closest('.rev-load-more')){
        reviewCards.filter(function(card){return card.hidden;}).slice(0,5).forEach(function(card){card.hidden=false;prepareReview(card);});
        reviewMore.hidden=!reviewCards.some(function(card){return card.hidden;});
      }
    });
    addEventListener('resize',function(){reviewCards.forEach(function(card){if(!card.hidden)prepareReview(card);});});
  }

})();

